import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

export type PeopleOverviewResponse = {
  success: boolean
  total: number
  locations: Record<string, number>
}

interface PeopleOverviewRequest {
  sheriffTypes?: readonly string[]
}

export function usePeopleOverview(request?: PeopleOverviewRequest) {
  return useQuery<PeopleOverviewResponse>({
    queryKey: ["people-overview-summary", request],
    queryFn: async () => {
      const body: Record<string, unknown> = {}
      if (request?.sheriffTypes) {
        body.sheriffTypes = request.sheriffTypes
      }
      const { data, error } = await supabase.functions.invoke<PeopleOverviewResponse>(
        "people-overview-summary",
        { body },
      )
      if (error) throw error
      return data as PeopleOverviewResponse
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
